
export default {
  name: "NotFound"
};
